import React, { useEffect, useState } from 'react';
import {
  getTokenInfos,
  validatePriceAndGetMinAmounts,
  depositETH,
  getLenderInfo,
  findBestLender,
  borrowETH
} from '../../functions/lendingfunctions.js';
import {
  getAmountOut,
  getNativetoUSDC,
  getPairAddressForBondedTokenForGraph
} from '../../functions/factoryFunctions.js';
import { popupManager } from "../common/PopupManager";

const verifiedTokens = [
  '0xdAC17F958D2ee523a2206206994597C13D831ec7', // USDT
  '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', // USDC
];

async function getTokenInfo(tokenAddress) {
  try {

    const tokenInfos = await getTokenInfos(tokenAddress);
    const tokenPrice = await getAmountOut(
      tokenAddress,
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      1,
      'ethereum'
    );
    const ethPrice = await getNativetoUSDC('ethereum');
    const usdPrice = Math.round(tokenPrice * ethPrice * 1000) / 1000;
    const depositedTokens = await validatePriceAndGetMinAmounts(tokenAddress, tokenInfos);
    let imageURL
    //console.log(tokenAddress)
    if(tokenAddress === "0xdAC17F958D2ee523a2206206994597C13D831ec7"){
      imageURL = "https://assets.coingecko.com/coins/images/325/standard/Tether.png"
    }else if(tokenAddress=== "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"){
      imageURL = "https://assets.coingecko.com/coins/images/6319/standard/usdc.png"
    }
    //console.log(imageURL)
    return [tokenInfos,usdPrice,depositedTokens,imageURL]
    
  } catch (e) {
    console.log(e);
    return [null,null,null]
  }
}



export default function Borrow({ signer ,validateChainId,handleWithdrawETH}) {
  const [tokens, setTokens] = useState([]);
  const [depositedETH, setdepositedETH] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [tokenAmount, settokenAmount] = useState('');

  // For the modal
  const [showModal, setShowModal] = useState(false);
  const [selectedToken, setSelectedToken] = useState('');
  const [ethAmount, setEthAmount] = useState('');
  const [ShowBorrowETH, setShowBorrowETH] = useState(false);
  // Fetch tokens on component mount
    useEffect(() => {
      async function fetchTokens() {
        try {
          setIsLoading(true);
  
          const response = await fetch(
            `https://qwertz.ink/vistalend/borrowAPY`
          );
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
  
          const fetchedTokens = await Promise.all(
            data.map(async (token) => {
              const [tokenInfos, usdPrice, depositedTokens, imageURL] = await getTokenInfo(token.Token);
              return {
                ...token, 
                tokenInfos,
                usdPrice,
                depositedTokens,
                imageURL
              };
            })
          );
          setTokens(fetchedTokens);
          setIsLoading(false);
  
        } catch (error) {
          console.error('Error fetching token data:', error);
          setIsLoading(false);
  
        } finally {
        }
      }
  
      fetchTokens();
    }, []);

    useEffect(() => {
      let intervalId;
    
      async function fetchdepositedETH() {
        try {
          const lendersInfo = await getLenderInfo(await signer.getAddress());
          setdepositedETH(lendersInfo);
        } catch (error) {
          console.error('Error fetching deposited ETH', error);
        }
      }
    
      // Call once on mount
      fetchdepositedETH();
    
      // Set up the interval to call it every 15 seconds
      intervalId = setInterval(() => {
        fetchdepositedETH();
      }, 15000);
    
      // Cleanup the interval on unmount
      return () => {
        clearInterval(intervalId);
      };
    }, [signer]);
    

  const handleLendClick = (token) => {
    setSelectedToken(token);
    setShowBorrowETH(true);
  };


  const handleBorrowClick = () => {
    setShowModal(true);
  };
  const handleBorrowETHClick = () => {
    setShowBorrowETH(true);
  };
  const handleBorrowETHClose = () => {
    setShowBorrowETH(false);
  };

  // Close the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setEthAmount('');
  };
    
    
      // Handle the "Send" button logic
    const handleBorrow = async () => {
        if (!selectedToken) return;
        let id = Date.now();
    
        try {
        const validateChain = await validateChainId(signer)
        popupManager.addPopup({
          id: id,
          type: "message",
          message: `Borrowing for ${tokenAmount} ${selectedToken.symbol} worth of ETH`,
        });
          const bestLender = await findBestLender(selectedToken.Token,tokenAmount,await signer.getAddress())

         const response = await borrowETH(bestLender.lender,tokenAmount,selectedToken.Token,signer)
         popupManager.removePopup(id);
         let successful_id = Date.now();
         popupManager.addPopup({
           id: successful_id,
           type: "success",
           message:
             "Transaction sent!",
         });
        } catch (e) {
          popupManager.removePopup(id);
          popupManager.addPopup({
            id: Date.now(),
            type: "error",
            message: e.toString(),
            duration: 6000,
          });
          console.log(e)
        }
    
        // Reset and close
        handleCloseModal();
      };

  const handleSend = async () => {
    let id = Date.now();

    try {
      const validateChain = await validateChainId(signer)
      popupManager.addPopup({
        id: id,
        type: "message",
        message: `Lending ${ethAmount} Ethereum`,
      });
      const usdcAddress = '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48'; // Example USDC address
      const usdtAddress = '0xdAC17F958D2ee523a2206206994597C13D831ec7'; // Example USDT address
      const stableCoinAddress = Math.random() < 0.5 ? usdcAddress : usdtAddress;
      const pairAddress = await getPairAddressForBondedTokenForGraph(
        stableCoinAddress,
        "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        'ethereum'
      );
      const response = await depositETH(ethAmount, pairAddress, signer);
      popupManager.removePopup(id);
      let successful_id = Date.now();
      popupManager.addPopup({
        id: successful_id,
        type: "success",
        message:
          "Transaction sent!",
      });

    } catch (e) {
      popupManager.removePopup(id);
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: e.toString(),
        duration: 6000,
      });
      console.log(e)
    }

    // Reset and close
    handleCloseModal();
  };

  return (
    <div className="w-full mt-4 sm:mt-0">

      {/* Header Section */}
      <div className=" mb-2 flex justify-between items-center">
        <div className='flex'>
        <h2 className="text-[14px] xs:text-[17px] sm:text-[19px] md:text-[23px] mt-3 mb-2  text-start font-semibold">Lending Pools</h2>

       {}


        </div>

        <div className="flex justify-end">
          
          <div className='flex gap-1 sm:gap-4 items-center'>
            <button
            disabled={signer === null}
              className="bg-yellow-400/10 hover:bg-yellow-400/15 border text-[10px] sm:text-[12px] font-semibold border-yellow-400/40 hover:border-yellow-400/50 rounded-sm ease-in duration-100 text-gray-300 hover:text-gray-100 w-[86px] xs:w-28 md:w-40 py-[4px] sm:py-[5px] md:py-[6px] mx-0"
              onClick={() => handleBorrowClick()}
            >
              Provide ETH
            </button>
            <button
            disabled={signer === null}
              className="bg-red-400/10 hover:bg-red-400/15 border text-[10px] sm:text-[12px] font-semibold border-red-400/40 hover:border-red-400/50 rounded-sm ease-in duration-100 text-gray-300 hover:text-gray-100 w-[86px] xs:w-28 md:w-40 py-[4px] sm:py-[5px] md:py-[6px] mx-0"
              onClick={() => handleWithdrawETH()}
            >
              Remove {!(depositedETH.ETHAvailable> 0) ? 0 : Math.round(depositedETH.ETHAvailable*1000)/1000} ETH 
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-4 sm:grid-cols-5 p-2 pr-0 border-b text-white/50 font-[300] border-white/10 text-[9px] xxs:text-[10px] sm:text-[11px] md:text-[14px]">
        <div className="flex justify-start">Asset</div>
        <div className='hidden sm:block'>Price</div>
        {/*<div className='hidden sm:block'>APY</div>*/}
        <div>Tokens Provided</div>
        <div>Total ETH Lent</div>
        <div className='flex justify-end  '><p className='px-2 sm:px-3 md:px-4 w-32 flex justify-center '>Borrow ETH</p></div>

      </div>

      {isLoading ? (
        verifiedTokens.map((_, index) => (
          <div
  key={index}
  className="grid grid-cols-4 sm:grid-cols-5 p-2 pr-0 border-b border-white/10 text-white/50 font-[300] text-[9px] xxs:text-[10px] sm:text-[11px] md:text-[14px]"
>
  {/* 1) Asset */}
  <div className="flex items-center gap-2 flex items-center">
    <div className="w-6 h-6 bg-white/10 rounded" />
    <div className="w-16 md:w-20 h-4 bg-white/10 rounded" />
  </div>

  {/* 2) Price (hidden on mobile) */}
  <div className="hidden sm:block flex items-center">
    <div className="mx-auto w-16 md:w-20 h-4 bg-white/5 rounded" />
  </div>

  {/* 3) APY (hidden on mobile) 
  <div className="hidden sm:block flex items-center">
    <div className=" mx-auto  w-16 md:w-20 h-4 bg-white/5 rounded" />
  </div>*/}

  {/* 4) Tokens Provided */}
  <div className='flex items-center'>
    <div className="mx-auto w-16 md:w-20 h-4 bg-white/5 rounded" />
  </div>

  {/* 5) Total ETH Lent */}
  <div className='flex items-center'>
    <div className="mx-auto w-16 md:w-20 h-4 bg-white/5 rounded" />
  </div>

  {/* 6) Borrow ETH */}
  <div className="flex items-center justify-end mr-6">
    <div className="w-16 md:w-20 h-4 bg-white/5 rounded" />
  </div>
</div>

        ))
      ) : (
        // Actual token rows once loaded
        tokens.map((token, index) => (
          <div
            key={index}
            className="grid grid-cols-4 sm:grid-cols-5 items-center hover:bg-white/5 py-3 sm:pl-2 pr-0 text-[12px] sm:text-sm inter-400"
          >
            <div className="flex items-center gap-4 font-semibold">
              {token.imageURL ? (
                <img src={token.imageURL} alt="Token" className="w-6 h-6" />
              ) : (
                <div className="w-6 h-6 bg-white/20 rounded" />
              )}
              {token.symbol}
            </div>
            <div className='hidden sm:block'>${Math.round(token.usdPrice*100)/100}</div>
            {/*<div className='hidden sm:block'>{token.APY !== null  ? `${Math.round(token.APY*100)/100}%` : `-`}</div>*/}
            <div>{token.depositedTokens.success === true ? Math.round(token.depositedTokens.tokenMin*100)/100 : "-" }</div>
            <div>{token.depositedTokens.success === true ? Math.round(token.depositedTokens.ethMin*10000)/10000 : "-" }</div>
            <div className="flex justify-end">
              <button
                className="bg-white/5 hover:bg-yellow-400/10 border text-[10px] sm:text-[12px] border-transparent hover:border-yellow-400/40 rounded-sm ease-in duration-100 text-white w-32 py-[4px] sm:py-[6px] px-[6px] xxs:px-2 sm:px-3 md:px-4 md:mr-[5px]"
                onClick={() => handleLendClick(token)}
              >
                Borrow ETH
              </button>
            </div>
          </div>
        ))
      )}

      {/* Modal Overlay + Popup */}
      {showModal  && (
        <div
          className="
            fixed inset-0 
            bg-black/40 
            backdrop-blur-sm 
            flex 
            items-center 
            justify-center 
            z-50
          "
        >
          <div
            className="
              bg-[#0e1018]
              border 
              border-yellow-300/30
              text-white
              max-w-sm 
              w-full 
              mx-2 
              p-6 
              rounded-lg 
              shadow-lg
            "
          >
            {/* Modal Header */}
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2">
                <h3 className="text-lg font-semibold text-white">
                  Provide ETH 
                </h3>
                
              </div>

              <button
                onClick={handleCloseModal}
                className="
                  text-white
                  transition-colors 
                  text-xl
                "
              >
                &times;
              </button>
            </div>

            {/* Modal Content */}
            <div className="flex flex-col space-y-4">
              <label>
                <span className="text-sm text-white text-start w-full ">
                  Enter Amount of ETH:
                </span>
                <input
                  type="number"
                  className="
                    mt-1 
                    block 
                    w-full 
                    rounded-md 
                    border 
                    border-white/30
                    bg-[#0e1018]
                    focus:outline-none
                    p-2
                  "
                  value={ethAmount}
                  onWheel={e => e.target.blur()}  
                  onChange={(e) => setEthAmount(e.target.value)}
                  placeholder="0.00"
                />
              </label>

              <button
                onClick={handleSend}
                className="
                  w-full 
                  bg-white/10
                  hover:bg-yellow-400/10
                  text-white
                  border
                  border-transparent
                  hover:border-yellow-400/40
                  font-semibold 
                  py-2 
                  px-4 
                  rounded-md 
                  transition-colors
                "
              >
                Provide ETH
              </button>
              <span className="text-[13px] text-gray-500">
                ETH Deposits must be equivalent to at least $100 or the transaction will fail.
              </span>
            </div>
          </div>
        </div>
      )}
    {ShowBorrowETH && (
        <div
          className="
            fixed inset-0 
            bg-black/40 
            backdrop-blur-sm 
            flex 
            items-center 
            justify-center 
            z-50
          "
        >
          <div
            className="
              bg-[#0e1018]
              border 
              border-yellow-300/30
              text-white
              max-w-sm 
              w-full 
              mx-2 
              p-6 
              rounded-lg 
              shadow-lg
            "
          >
            {/* Modal Header */}
            <div className="flex justify-between items-center mb-4">
              <div className='flex items-center gap-2'>
                <h3 className="text-lg font-semibold text-white">
                  {selectedToken.symbol}
                </h3>
                {selectedToken.imageURL && (
                  <img 
                    src={selectedToken.imageURL} 
                    className="w-6 h-6" 
                    alt={selectedToken.symbol}
                  />
                )}
              </div>

              <button
                onClick={handleBorrowETHClose}
                className="
                  text-white
                  transition-colors 
                  text-xl
                "
              >
                &times;
              </button>
            </div>

            {/* Modal Content */}
            <div className="flex flex-col space-y-4">
              <label>
                <span className="text-sm text-white text-start w-full">
                Enter amount of tokens to provide:
                </span>
                <input
                  type="number"
                  className="
                    mt-1 
                    block 
                    w-full 
                    rounded-md 
                    border 
                    border-white/30
                    bg-[#0e1018]
                    focus:outline-none
                    p-2
                  "
                  value={tokenAmount}
                  onWheel={e => e.target.blur()}  
                  onChange={(e) => settokenAmount(e.target.value)}
                  placeholder="0.00"
                />
              </label>

              <button
                onClick={handleBorrow}
                className="
                  w-full 
                  bg-white/10
                  hover:bg-yellow-400/10
                  text-white
                  border
                  border-transparent
                  hover:border-yellow-400/40
                  font-semibold 
                  py-2 
                  px-4 
                  rounded-md 
                  transition-colors
                "
              >
                Borrow
              </button>
              <span className="text-[13px] text-white">
                Lock Time: 7 days 
              </span>
              <span className="text-[13px] text-white">
                Total value must be more than 100$ 
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
